<template>
    <div class="content" @focusout="temporaryRepair" @focusin="focus">
        <div class="box iphone-box">
            <div class="container">
                <div
                 class="input-box"
                 :class="{
                  error: !phoneValid
                }">
                   <input
                    type="text"
                    id="iphone"
                    v-model="tel"
                    placeholder="请输入手机号"
                    :maxlength="11">
                <div class="des" v-show="!phoneValid">
                    请输入正确的手机号码
                </div>
                </div>

            </div>
        </div>
        <div class="box name-box">
            <div class="container">
                <div
                class="input-box2"
                >
                   <input
                    class="inputWidth"
                    type="text"
                    id="name"
                    v-model="verificationCode"
                    placeholder="请输入验证码"
                    :maxlength="6">
                  <div class="getCode getCodeActive" :class="canGet?'getCodeActive':'getCodeNotBtn'"
                  v-if="!getCode" @click="clickGetCode"></div>
                  <div class="getCode getCodeNot" v-else>重新发送{{`${countdownText}`}}</div>
                </div>

            </div>
        </div>
        <div
         class="btn"
         :class="this.canGet&&this.codeAct?'activeBackImgBtn':'backImgBtn'"
          @click="getCoupon"
          ></div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import toast from '@ali/act-util/toast';
import { util, log, webviewInfo } from '@ali/amap-lib';
import http from '../js/http';
import MsgBox from '../js/msgbox';
import CONFIG_URL from '../../config/config.url';
import CONFIG_ACT from '../../config/config.act';
import { EventBus } from '../js/event-bus';

// 手机号码的验证
const phoneReg = /^(1[3-9])\d{9}$/;
// 验证码验证
const codeReg = /^[0-9]{6}$/;
export default {
  name: 'GetInfo',
  data() {
    return {
      tel: '', // 手机号
      verificationCode: '', // 验证码
      timer: null,
      countDownTimer: null,
      countdownText: '60s', // 倒计时文案
      getCode: false, // 验证码点击状态
      token: '',
      clickCouponFlag: false,
      isInWeixin: webviewInfo.isInWeixin(),
      gasURL: '', // 加油url
      couponList: [], //  券数组
      couponState: true, //  券领取状态
      inviteChannel: '' // 邀请渠道
    };
  },
  props: {
    getCouponFlag: {
      default: false,
      type: Boolean
    },
    share_channel: {
      type: String,
      default: '',
    },
    startTime: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 电话号码验证
    phoneValid() {
      return this.tel ? phoneReg.test(this.tel.trim()) : true;
    },
    // 是否可以获取验证码
    canGet() {
      return this.tel && this.phoneValid;
    },
    // 验证码是否填写正确
    codeAct() {
      return codeReg.test(this.verificationCode.trim());
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    } else if (this.countDownTimer) {
      clearTimeout(this.countDownTimer);
      this.countDownTimer = null;
    }
  },
  created() {
    console.log(this.startTime, this.share_channel, this.getCouponFlag, '信息组件props参数');
    this.token = util.getUrlParam('token') || '';
    this.inviteChannel = util.getUrlParam('inviteChannel') || '';
    console.log(11112321123, this.inviteChannel, this.token);
    log.log('popup_show', {
      active_state: '',
      activity_id: CONFIG_ACT.actId,
      uid: '',
      channel_ID: this.share_channel,
      type: 'popup_login'
    });
  },
  methods: {
    // 老用户弹窗
    isOld() {
      log.log('popup_show', {
        active_state: '',
        activity_id: CONFIG_ACT.actId,
        uid: '',
        channel_ID: this.share_channel,
        type: 'popup_old'
      });
      MsgBox({
        content: '只有高德加油新用户才能领取哦', // 提示文案
        hasClose: true, // 默认没有关闭按钮
        closeFun: null, // 点击关闭按钮触发的方法
        btns: [
          // msgbox按钮列表，可以多个按钮
          {
            text: '赚更多奖励',
            fun: () => {
              log.log('popup_click', {
                active_state: '',
                activity_id: CONFIG_ACT.actId,
                channel_ID: this.share_channel,
                click_type: 'popup_old_earn'
              });
              if (this.isInWeixin) {
                const url = `${CONFIG_URL.index}?from=popup_old&act_id=${CONFIG_ACT.actId}`;
                this.gasURL = `amapuri://webview/amaponline?url=${encodeURIComponent(url)}&hide_title=1`;
              } else {
                const url = `${CONFIG_URL.index}?from=popup_old%26act_id=${CONFIG_ACT.actId}`;
                this.gasURL = `amapuri://webview/amaponline?url=${encodeURIComponent(url)}`;
              }
              this.$emit('jumpUrl', this.gasURL);
            }, // 点击按钮触发的方法
            noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
          },
          {
            text: '去加油', // 按钮文案
            fun: () => {
              log.log('popup_click', {
                active_state: '',
                activity_id: CONFIG_ACT.actId,
                channel_ID: this.share_channel,
                click_type: 'popup_old_gas'
              });
              const url = 'amapuri://search/general?keyword=加油站&dev=1&record_history=0&source=930&transparent=gasstation_portal_gasdiscountflagterm_1&superid=z_99_1711';
              this.$emit('jumpUrl', url);
            }, // 点击按钮触发的方法
            noClose: false // 是否不需要关闭弹窗，默认（false）需要关闭
          }
        ]
      });
    },
    // 点击获取验证码
    async clickGetCode() {
      if (!this.getCode && this.canGet) {
        this.getCode = true;
        // 开启倒计时
        this.autoClose();
        const res = await http.verify_code('', '', this.tel).catch((error) => {
          const {
            code,
            aosurl
          } = error;
          log.log('login_click', {
            active_state: '',
            activity_id: CONFIG_ACT.actId,
            uid: '',
            channel_ID: this.share_channel,
            status: 'fail',
            click_type: 'sms_code'
          });
          if (+code === 151) {
            toast('本日获取验证码超过限制');
            return;
          }
          if (+code === 140) {
            toast('操作频繁，稍后重试');
            return;
          }
          if (+code === 134) {
            toast('手机号填写不正确');
            return;
          }
          toast('验证码获取失败，稍后重试');
          console.log(aosurl, +code, res);
          return false;
        });
        if (res) {
          log.log('login_click', {
            active_state: '',
            activity_id: CONFIG_ACT.actId,
            uid: '',
            channel_ID: this.share_channel,
            status: 'succeed',
            click_type: 'sms_code'
          });
        }
      } else if (!this.canGet) {
        toast('填写手机号有误'); // todo 文案确认是否需要修改
      }
    },
    /**
     * @description: 自动关闭逻辑
     * @param {*}
     * @return {*}
     */
    autoClose() {
      let count = 60;
      this.countDownTimer = setInterval(() => {
        count--;
        this.countdownText = `${count}s`;
        if (count === 0) {
          this.getCode = false;
          if (this.countDownTimer) {
            clearTimeout(this.countDownTimer);
            this.countDownTimer = null;
            this.getCode = false;
            this.countdownText = '60s'; // 初始化时间
          }
        }
      }, 1000);
    },
    // 点击立即领取按钮
    async getCoupon() {
      console.log('防连点');
      // 领券防连点
      if (this.clickCouponFlag) return;
      this.clickCouponFlag = true;
      if (!this.canGet) {
        this.clickCouponFlag = false;
        toast('填写手机号有误');
        return;
      }
      if (!codeReg.test(this.verificationCode.trim())) {
        this.clickCouponFlag = false;
        toast('填写验证码有误');
        return;
      }
      this.callBack();
    },
    // 获取优惠券接口
    async callBack() {
      const res = await http.call_back(
        '', '', this.tel, this.verificationCode, this.token, '', this.inviteChannel
      )
        .catch((error) => {
          const {
            code,
            aosurl
          } = error;
          this.clickCouponFlag = false;
          log.log('login_click', {
            active_state: '',
            activity_id: CONFIG_ACT.actId,
            uid: '',
            channel_ID: this.share_channel,
            status: 'fail',
            click_type: 'login_get_coupon'
          });

          if (+code === 0) {
            toast('未知错误，请重试');
            return;
          }
          if (+code === 2) {
            toast('访问失败，请重试');
            return;
          }
          if (+code === 3) {
            toast('参数异常，请重试');
            return;
          }
          if (+code === 4) {
            toast('签名异常，请重试');
            return;
          }
          if (+code === 7) {
            toast('未找到信息，请重试');
            return;
          }
          if (+code === 134) {
            toast('领券异常，请重试');
            return;
          }
          if (+code === 151) {
            toast('助力次数已用完');
            return;
          }
          if (+code === 140 || +code === 136) {
            toast('token错误请重试');
            return;
          }
          if (+code === 201) {
            toast('优惠券不足');
            return;
          }
          if (+code === 135) {
            toast('不能邀请自己');
            return;
          }
          if (+code === 131) {
            toast('验证码校验失败');
            return;
          }
          // 老用户时弹出
          if (+code === 130) {
            this.isOld();
            return;
          }
          // 已领取过
          if (+code === 119) {
            this.couponState = false;
            EventBus.$emit('openInfoModal', { list: [], state: this.couponState });
            return;
          }
          // 黑产
          if (+code === 203) {
            toast('领取失败');
            return;
          }
          // 未绑定支付宝
          if (+code === 1001) {
            toast('未绑定支付宝账号');
            return;
          }
          // 未绑定淘宝
          if (+code === 1002) {
            toast('未绑定淘宝账号');
            return;
          }
          // 未绑定饿了么
          if (+code === 1003) {
            toast('未绑定饿了么账号');
            return;
          }
          const errorMsg = {
            107: '优惠券发完了，下次早点来',
            113: '邀请人数已达到上限',
            102: '活动还未开始，请稍等',
            103: '活动已结束',
            104: '活动已下线',
            112: '请勿重复操作',
          };

          const msg = errorMsg[code];
          if (msg) {
            toast(msg);
            return;
          }

          toast('领取失败，稍后重试');
          console.log(aosurl, +code);
          return false;
        });
      if (res) {
        log.log('login_click', {
          active_state: '',
          activity_id: CONFIG_ACT.actId,
          uid: '',
          channel_ID: this.share_channel,
          status: 'succeed',
          click_type: 'login_get_coupon'
        });
        toast('领取成功，快去加油吧！');
        this.clickCouponFlag = false;
        // 缓存是否领取
        localStorage.setItem('2021GasInviter_getCouponFlag', true);
        const phone = `${this.tel.substr(0, 3)}****${this.tel.substr(7)}`;
        localStorage.setItem('2021GasInviter_phone', phone);
        localStorage.setItem('2021GasInviter_startTime', this.startTime);
        // 刷新首页接口
        await this.$emit('Refresh');
        this.couponState = true; // 是否领取成功或失败标识
        this.couponList = res.pictures || []; // 券列表成功领取后数据赋值
        EventBus.$emit('openInfoModal', { list: this.couponList, state: this.couponState });
      }
    },
    // 解决ios12键盘收起页面不能下来的问题
    temporaryRepair() {
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          console.log('timer触发');
          window.scrollTo(0, 0); // 页面向下滚动
        }, 0);
      });
    },
    focus() {
      console.log('focus聚焦');
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss">
@import "../css/common-mixin";
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    color:#b83102;
    text-align: center;
    .title{
        width: rpx(440);
        font-family: PingFangSC-Medium;
        text-align: center;
        font-size: rpx(46);
        font-weight: bolder;
        margin: 0 auto rpx(25);
    }
    .name{
        font-family: PingFangSC-Medium;
        text-align: center;
        font-size: rpx(28);
        font-weight: bolder;
        width: rpx(385);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 auto;
        margin-bottom: rpx(23);
    }
    .box{
        width: 100%;
        height: rpx(64);
        margin: 0 auto;
        &.name-box{
            margin-top: rpx(30);
            margin-bottom: rpx(8);
        }
        .container{
            width: 100%;
            .input-box{
              display: inline-block;
              width: rpx(535);
              height: rpx(64);
              padding: 0 rpx(30);
              box-sizing: border-box;
              position: relative;
              border-radius: rpx(30);
              background: #fff;
              &.error{
                    border-color: #be2a2a;
                    input{
                      color: #be2a2a;
                    }
              }
              input{
                width: 100%;
                height: 100%;
                padding: 0;
                border: none;
                outline-style: none ;
                font-size: rpx(30);
                color: #b83102;
                background-color: transparent;
                &:-internal-autofill-selected {
                  background-color: transparent!important;
                }
              }
              .des{
                width: 100%;
                margin-top: rpx(2);
                text-align: left;
                color: #fff;
                padding-left: rpx(10);
              }
           }
           .input-box2{
              display: inline-block;
              width: rpx(535);
              height: rpx(64);
              box-sizing: border-box;
              position: relative;
              display: flex;
              margin: 0 auto;
              &.error{
                    border-color: #be2a2a;
                    input{
                      color: #be2a2a;
                    }
              }
              .getCodeActive{
                background: url('../../assets/endPage/act-code-btn.png') no-repeat;
              }
              .getCodeNot{
                background: url('../../assets/endPage/not-click-code.png') no-repeat;
              }
              .getCodeNotBtn{
                background: url('../../assets/endPage/not-click-code-btn.png') no-repeat;
              }
              .getCode{
                width: rpx(184);
                height: rpx(63);
                padding: 0 rpx(7);
                margin-left: rpx(24);
                background-position: center;
                background-size: 100% 100%;
                font-size: rpx(24);
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                letter-spacing: rpx(-1);
              }
              input{
                width: rpx(360);
                height: 100%;
                padding-left: rpx(30);
                border: none;
                outline-style: none ;
                font-size: rpx(30);
                color: #b83102;
                background-color: transparent;
                border-radius: rpx(30);
                background: #fff;
                &:-internal-autofill-selected {
                  background-color: transparent!important;
                }
              }
           }
        }
    }
    .backImgBtn{
      background: url("../../assets/endPage/not-click-btn.png") center no-repeat;
    }
    .activeBackImgBtn{
      background: url("../../assets/endPage/get-coupon-act-btn.png") center no-repeat;
    }
    .btn {
      margin: rpx(28) auto 0;
      width: rpx(540);
      height: rpx(86);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      background-size: 100% 100%;
    }
    .des{
      width: rpx(440);
      margin: 0 auto;
      text-align: center;
      font-size: rpx(22);
    }
  }
  // 修改palceholder字体颜色
  input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c83c0e;
  }
  input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c83c0e;
  }
  input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c83c0e;
  }
  input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c83c0e;
  }
</style>
